import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  FaGithub, 
  FaLinkedin, 
  FaTwitter, 
  FaEnvelope,
  FaHeart,
  FaArrowUp
} from 'react-icons/fa';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-900/50 backdrop-blur-xl border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            {/* ===== LOGO - USING YOUR IMAGE ===== */}
            <Link to="/" className="block mb-4">
              <img 
                src="/logo.png" 
                alt="YoungDev Technologies" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm max-w-md leading-relaxed">
              Building innovative software solutions across web, backend, blockchain, and embedded systems. Committed to excellence and impact.
            </p>
            <div className="flex gap-4 mt-4">
              <a 
                href="https://github.com/developer13-art" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 text-gray-400 hover:text-white"
              >
                <FaGithub size={18} />
              </a>
              <a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 text-gray-400 hover:text-white"
              >
                <FaLinkedin size={18} />
              </a>
              <a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 text-gray-400 hover:text-white"
              >
                <FaTwitter size={18} />
              </a>
              <a 
                href="mailto:your.email@example.com"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 text-gray-400 hover:text-white"
              >
                <FaEnvelope size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">About</Link></li>
              <li><Link to="/projects" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">Projects</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">Services</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">Blog</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/hire" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">Hire Me</Link></li>
              <li><Link to="/mentorship" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">Mentorship</Link></li>
              <li><Link to="/open-source" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">Open Source</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-all duration-300 text-sm">Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} YoungDev Technologies. Built with 
            <FaHeart className="inline-block text-red-500 mx-1 animate-pulse" size={12} />
            and passion.
          </p>
          
          <div className="flex items-center gap-6 text-sm">
            <span className="text-gray-500">v1.0.0</span>
            <span className="text-gray-600">|</span>
            <span className="text-gray-500">MIT License</span>
          </div>

          <button
            onClick={scrollToTop}
            className="p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 text-gray-400 hover:text-white"
          >
            <FaArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;